import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalErrorProps {}

export const ModalError: FunctionComponent<IModalErrorProps> = observer<FunctionComponent<IModalErrorProps>>(function () {
    const { translateStore } = useStorageTranslateContext();

    let openModalError = translateStore.openModalError;

    return (
        <div>
            <Dialog open={openModalError} onClose={() => translateStore.handleCloseModalError()} aria-describedby='alert-dialog-description'>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>File saving error. Please, contact administrator.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            translateStore.handleCloseModalError();
                        }}
                        color='primary'>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
});
